import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, isMember, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // If user is authenticated, redirect to appropriate dashboard
  if (isAuthenticated) {
    // Get the intended destination from state, or use default based on role
    const from = location.state?.from?.pathname;
    
    if (from && from !== '/login' && from !== '/register') {
      return <Navigate to={from} replace />;
    }
    
    // Default redirects based on user role
    if (isAdmin) {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (isMember) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // User is not authenticated, show the public page
  return <>{children}</>;
};

export default PublicRoute; 